<template>
<div class="container">
  <div class="row">
    <div class="container mt-3">
        <div class="row row-titulo-registro">
            <div class="col-2 mt-4">
                <a target="_self" href="https://houseandflats.com/"> 
                <img class="logo" src="../assets/logo.png" >
                </a>
            </div>
            <div class="col-8 text-center title-registro-parent">      
                <label class="title title-registro">Inicio de sesión</label>    
            </div>
        </div>
        <hr>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6">
      <div class="login-container">
        <h3 class="u-section-title" style="color: #662483;">Inicia sesión para continuar</h3>
        <br>
        <form class="login" @submit.prevent="login({correo:correo,hash:hash})">
          <input required v-model="correo" type="text" placeholder="Correo eletrónico" class="form-control form-control-lg input-login"/>
          <br>
          <input required v-model="hash" type="password" placeholder="Contraseña" class="form-control form-control-lg input-login"/>
          <br>
          <div class="row">
            <div class="col-md-12 row-footer-form">
              <div class="olvido-clave-container">
              <a href="https://houseandflats.com/auth/recuperar" style="color: #662483;">Olvidé mi contraseña</a>
            </div>
            <div class="login-btn-container">
              <button type="submit" class="btn btn-lg btn-primary btn-login-new">Login</button>
            </div>
            </div>
          </div>
        </form>
      </div>
    </div>


    <div class="col-md-6" >
      <div class="login-container">
        <h3 class="u-section-title" style="color: #662483;">Registrate</h3>
        <br>
        <router-link style="color: #662483;width: 100%;" class="btn btn-lg btn-primary btn-login-new" to="/">Ir al registro</router-link>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import router from '@/router'
export default {
  name: 'Ingreso',
  data(){
    return{
      correo: '',
      hash: ''
    }
  },
  methods:{
    ...mapActions(['login'])
  },
  computed:{
    ...mapState(['error'])
  },
  created () {
    if(this.$store.getters.isLoggedIn){
        router.push({name: 'Dashboard'})
    }  
  }
}
</script>